import React from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import Paper from "@material-ui/core/Paper";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import {Button} from "primereact/button";
import {Divider} from "@material-ui/core";
import {PickList} from "primereact/picklist";
import {InputText} from "primereact/inputtext";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";

const CreateEditGroupView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <div className="p-grid">
                    <div className="p-col-7">
                        <TitlePage title={props.group !== '' ? "Mantenimiento \\ Tipos Valor \\ Editar Grupo" :
                            "Mantenimiento \\ Tipos Valor \\ Agregar Grupo"}/>
                    </div>
                    <div className="p-col-5" align="right">
                        <Button label="Regresar" className="p-button-secondary"
                                onClick={props.returnPage}
                        />&nbsp;
                        <Button label="Guardar"
                                onClick={props.group !== '' ? props.editGroup : props.createGroup}
                        />
                    </div>
                </div>
                <div className="p-col-6" style={{padding: '.5em'}}>
                    <SubtitleLabel header="Nombre del Grupo" isBold={true}/>
                    {
                        props.group !== '' &&
                        props.group.groupName
                    }

                    {
                        props.group === '' &&
                        <InputText name="groupName"
                                   onChange={props.onChangeText}
                                   value={props.groupName}
                        />
                    }
                </div>
                <div className="p-col-12"><Divider/></div>
                <div className="p-col-10">
                    <PickList source={props.sourceProcess} target={props.targetProcess}
                              itemTemplate={props.processTemplate}
                              sourceHeader="Valores Disponibles" targetHeader="Valores Asignados" responsive={true}
                              sourceStyle={{height: '500px'}} targetStyle={{height: '500px'}}
                              onChange={props.onChangePickList}
                              showSourceControls={false} showTargetControls={false}
                    />
                </div>
            </Paper>
        </React.Fragment>
    )
};
export default (CreateEditGroupView);